import { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Box, ContentLabelField, Svg, Text } from '@hopskipdrive/react-components';
import { MenuItem } from '@mui/material';
import * as Yup from 'yup';

import { useGetActions } from '../../../hooks/useIncidentApi';
import { PlaceholderText, SelectClearButton, StyledSelect } from '../IncidentForm.styles';

interface ActionTakenFieldProps {
  defaultValue?: string;
}

export const actionTakenValidation = Yup.string().nullable();

export const ActionTakenField = ({ defaultValue }: ActionTakenFieldProps): ReactElement => {
  const { isSuccess, data: response } = useGetActions();
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name: 'actionTaken',
    control,
    defaultValue,
  });

  return (
    <ContentLabelField
      id="actionTaken"
      title="Action taken"
      editMode={true}
      editView={
        isSuccess && response?.data ? (
          <StyledSelect
            error={!!fieldState.error}
            fullWidth
            endAdornment={
              field.value ? (
                <SelectClearButton
                  className="clearBtn"
                  onClick={() => {
                    field.onChange(null);
                  }}
                >
                  <Svg icon="cancel-filled" />
                </SelectClearButton>
              ) : null
            }
            displayEmpty
            MenuProps={{
              BackdropProps: {
                style: {
                  opacity: 0,
                },
              },
            }}
            value={field.value || ''}
            onChange={(e) => field.onChange(e.target.value)}
            renderValue={(selected) => {
              if (!selected) {
                return <PlaceholderText>Select action taken against offender</PlaceholderText>;
              }

              const selectedOption = response?.data.find((option) => option.value === selected);

              return selectedOption ? (
                <Box>
                  <Text variant="body2">{selectedOption.label}</Text>
                </Box>
              ) : null;
            }}
          >
            {response?.data.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <Text variant="body1">{option.label}</Text>
              </MenuItem>
            ))}
          </StyledSelect>
        ) : (
          <div />
        )
      }
    />
  );
};
